import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const forgeProjectEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-forge-project-entrypoint" */ './src'),
	),
	getPreloadProps: ({ context }: EntryPointRouteParams) => ({
		extraProps: {
			match: context.match,
		},
	}),
});
